import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["parentSelect", "childFields"]

  connect() {
    this.#toggleChildFields()
  }

  toggleChildFields() {
    this.#toggleChildFields()
  }

  #toggleChildFields() {
    this.childFieldsTarget.classList.toggle(this.hiddenClass, this.parentSelectTarget.value === "")
  }
}
